import { FinalValueResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: FinalValueResult;
  translations: ToolsTranslations['finalValue'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  if (!result.isValid) {
    return (
      <div className="space-y-6">
        <h3 className="text-lg font-medium text-gray-900">{translations.results.title}</h3>
        <div className="p-4 bg-red-50 border border-red-200 rounded-md">
          <p className="text-sm text-red-600">{result.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900">{translations.results.title}</h3>
      
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="text-center">
          <p className="text-sm text-blue-600 mb-2">{translations.results.finalAmountLabel}</p>
          <p className="text-3xl font-bold text-blue-900">
            {result.finalAmount?.toLocaleString('sv-SE')} kr
          </p>
        </div>
      </div>

      <div className="text-sm text-gray-600 space-y-2">
        <p>{translations.results.explanation}</p>
      </div>
    </div>
  );
}
